'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = require('./endpointTypes'),
    endpointTypes = _require.endpointTypes,
    isCloudEndpointType = _require.isCloudEndpointType;

var _require2 = require('./storageProfileTypes'),
    storageProfileTypes = _require2.storageProfileTypes,
    isCloudStorageProfileType = _require2.isCloudStorageProfileType;

/**
 * We are in a weird state right now where this index.js is the index for jet constants not for all constants.
 * See https://bitbucket.org/signiant/platform-common/src/2f629bd21a0029ac05fa796029cf1b418eac48b8/src/index.js?at=master#lines-10
 *
 * Unless someone wants to do a breaking major version update the present recommendation is to use this file for jet constants
 * alone currently.
 */


module.exports = _extends({
    actionBacklogStates: require('./actionBacklogStates'),
    actionBacklogStreamEventTypes: require('./actionBacklogStreamEventTypes'),
    actionExecutionEventTypes: require('./actionExecutionEventTypes'),
    actionExecutionStates: require('./actionExecutionStates'),
    actionTypes: require('./actionTypes'),
    addressGranularities: require('./addressGranularities'),
    authenticationConfigTypes: require('./authenticationConfigTypes'),
    deletionBatchStates: require('./deletionBatchStates'),
    deliveryStates: require('./deliveryStates'),
    deviceCommunicationServiceEvents: require('./deviceCommunicationServiceEvents'),
    deviceEvents: require('./deviceEvents'),
    deviceLocationResolutionMethods: require('./deviceLocationResolutionMethods'),
    endpointTypes: endpointTypes,
    endpointVisibility: require('./endpointVisibility'),
    errorCodes: require('./errorCodes'),
    errorHandlingPolicies: require('./errorHandlingPolicies'),
    fileDeletionEvents: require('./fileDeletionEvents'),
    fileDeletionStates: require('./fileDeletionStates'),
    fileMoveEvents: require('./fileMoveEvents'),
    fileMoveStates: require('./fileMoveStates'),
    fileStates: require('./fileStates'),
    fileTransfersSnsEvents: require('./fileTransfersSnsEvents'),
    fileTypes: require('./fileTypes'),
    folderMonitorInitializationStatuses: require('./folderMonitorInitializationStatuses'),
    folderMonitorStartModes: require('./folderMonitorStartModes'),
    gcpRegionTypes: require('./gcpRegionTypes'),
    hotFolderEventTypes: require('./hotFolderEventTypes'),
    isCloudEndpointType: isCloudEndpointType,
    isCloudStorageProfileType: isCloudStorageProfileType,
    jetDeletionEventStatusCodes: require('./jetDeletionEventStatusCodes'),
    jetMetricRawDataKeys: require('./jetMetricRawDataKeys'),
    jetMoveEventStatusCodes: require('./jetMoveEventStatusCodes'),
    jetVersions: require('./jetVersions'),
    jetServerErrorCodes: require('./jetServerErrorCodes'),
    jobTypes: require('./jobTypes'),
    licenseServiceTypes: require('./licenseServiceTypes'),
    licenseStatuses: require('./licenseStatuses'),
    mediaEngine: require('./mediaEngine'),
    moveBatchStates: require('./moveBatchStates'),
    msAuditLog: require('./msAuditLog'),
    resourceStatusStates: require('./resourceStatusStates'),
    resourceTypes: require('./resourceTypes'),
    routeTypes: require('./routeTypes'),
    signiantCommunicationServiceVersions: require('./signiantCommunicationServiceVersions'),
    storageProfileTypes: storageProfileTypes,
    storageProfileVisibility: require('./storageProfileVisibility'),
    tokenStates: require('./tokenStates'),
    transferEvents: require('./transferEvents'),
    transferStates: require('./transferStates'),
    userConstants: require('./userConstants'),
    jetTransferErrorReasons: require('./jetTransferErrorReasons'),
    jetJobStates: require('./jetJobStates'),
    credentialsRequestScope: require('./credentialsRequestScope'),
    cloudFolderMonitorErrorCodes: require('./cloudFolderMonitorErrorCodes'),
    apiClients: require('./apiClients')
}, require('./cloudVendors'), {
    jetServerTransferObjectClasses: require('./jetServerTransferObjectClasses'),
    formRenderer: require('./formRenderer'),
    s3BucketAccessStyle: require('./s3BucketAccessStyle')
});